import { makeStyles, css } from '@conexasaude/conexa-hero'

type UseStylesProps = {
  active?: boolean
}

const useStyles = makeStyles<UseStylesProps>({
  container: css`
    display: flex;
  `,
  whatsappLinkWrapper: ({ spacing, border, fontSizes, colors, grid }) => css`
    position: fixed;
    bottom: 0;
    right: ${spacing.xxs};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .whatsapp-link {
      margin: ${spacing.xs};
      border: none;
      border-radius: ${border.radius.full};
      padding: ${spacing.xxs} ${spacing.xs};
      display: flex;
      flex-direction: row;
      width: fit-content;
      align-items: center;
      background: ${colors.brand.primary[400]};
      font-weight: bold;
      font-size: ${fontSizes.md};
    }
    .whatsapp-link div {
      padding: 0 ${spacing.xxs};
      color: ${colors.background.white};
    }

    .iconTalk {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    @media (max-width: ${grid.breakpoint.sm}) {
      .whatsapp-link {
        padding: ${spacing.xs} ${spacing.xxs};

        .whatsapp-link__text {
          display: none;
        }
      }
      .whatsapp-link div {
        color: ${colors.background.white};
      }
    }
  `,
})
export { useStyles }
